export default "__VITE_ASSET__C4Y8pDRy__"